import { memo } from "react"
import { useHeaderVisibility } from "./hooks/use-header-visibility"

const BRACKET_LOGO_URL = "https://a.bracky.app/Brand%20Assets/bracket-lockup-horizontal-reverse.svg"
const BRACKET_MAIN_URL = "https://bracky.app"

const LandingHeaderBase = () => {
  const visible = useHeaderVisibility()

  const handleLogoClick = () => {
    window.location.href = BRACKET_MAIN_URL
  }

  const handleFAQClick = () => {
    const el = document.getElementById("faqs")
    if (el) el.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <header
      className={`fixed top-0 left-0 w-full md:hidden transition-opacity duration-300 ease-out ${
        visible ? "opacity-100 pointer-events-auto z-9999" : "opacity-0 pointer-events-none"
      }`}
    >
      {/* Match the same padding / offset as the in-app header */}
      <div className="flex items-center justify-between w-full px-4 pt-[2.95rem]">
        {/* Left block (logo + optional info icon) */}
        <div className="flex items-center gap-1">
          <button
            type="button"
            aria-label="Go to Bracky.app"
            onClick={handleLogoClick}
            className="outline-hidden focus:outline-hidden focus-visible:outline-hidden transition-all duration-150 active:scale-[0.98]"
          >
            <img
              src={BRACKET_LOGO_URL}
              alt="BRACKET"
              className="w-[9.01rem] ml-[.14rem] select-none opacity-50 hover:opacity-55 transition-all ease-in-out active:opacity-70"
              draggable="false"
              decoding="async"
            />
          </button>
        </div>

        {/* Right side controls */}
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={handleFAQClick}
            className="pointer-events-auto group flex items-center text-base font-medium text-white mr-[.5rem] transition-opacity duration-300 ease-in-out active:opacity-20"
          >
            <span className="transition-opacity duration-1000 ease-out group-active:duration-150">FAQ</span>
          </button>
        </div>
      </div>
    </header>
  )
}

export const LandingHeader = memo(LandingHeaderBase)
